import { render, staticRenderFns } from "./CustomUIProject.vue?vue&type=template&id=6d1e5df0&scoped=true&"
import script from "./CustomUIProject.vue?vue&type=script&lang=js&"
export * from "./CustomUIProject.vue?vue&type=script&lang=js&"
import style0 from "./CustomUIProject.vue?vue&type=style&index=0&id=6d1e5df0&prod&scoped=true&lang=css&"
import style1 from "./CustomUIProject.vue?vue&type=style&index=1&id=6d1e5df0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e5df0",
  null
  
)

export default component.exports